export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(value, max));
}

export const generateAlphaNumericRandom = (length: number) => {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  for (let i = 0; i < length; i += 1) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

export function wordCount(value?: string) {
  return value && value.trim() !== '' ? value.trim().split(/\s+/).length : 0;
}
